import { NavPayloadAction } from '@carvana/merch-native';
import DispatcherEvent from '@carvana/merch-native/DispatcherEvent';
import { useCallback } from 'react';
import { useIsNative } from '~/context/common/DeviceContext';
import { useMakeModelSearchLink } from '~/hooks/vdp';
import sendMessageToNative from '~/native/vdp/dispatchers/sendMessageToNative';

export default function useViewSimilarVehicles(): () => void {
  const viewSimilarVehiclesUrl = useMakeModelSearchLink();
  const isNative = useIsNative();

  return useCallback(() => {
    if (isNative) {
      const url = `${process.env.CVNA_APP_ABSOLUTE_BASE_URL}${viewSimilarVehiclesUrl}`;
      const cvnaid = new URL(url).searchParams.get('cvnaid');

      sendMessageToNative(DispatcherEvent.LeaveFullscreen, {});

      sendMessageToNative(DispatcherEvent.Link, {
        url,
        linkType: 'browser',
        action: NavPayloadAction.ViewSrp,
        cvnaid
      });
    } else {
      window.location.href = viewSimilarVehiclesUrl;
    }
  }, [isNative, viewSimilarVehiclesUrl]);
}
